import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type QuicklinksData = {
  links: {
    header: string
    linkTo: string
  }[]
  marginBottom?: string
  marginTop?: string
  backgroundColor?: 'white' | 'primary' | 'accent'
}

export const quicklinks: DynamicContentType<QuicklinksData> = {
  name: 'quicklinks',
  viewName: 'Genvägar',
  featureKey: 'quicklinks',
  icon: LucideIconName.SquareArrowOutUpRight,
  default: true,
  uuid: '',
  data: {
    backgroundColor: 'white',
    links: [
      {
        header: 'Min länk',
        linkTo: '/',
      },
      {
        header: 'Min länk',
        linkTo: '/',
      },
    ],
  },
}
